function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#5d1c9a",
  d: "M10.607 37.238l-8.485-8.486a3 3 0 010-4.242 3 3 0 014.242 0l8.485 8.485 20.507-20.506.014.014a3 3 0 013.989.226 3 3 0 01.225 3.988l.014.015L14.85 41.48z"
});
function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.479,
    height: 41.479,
    viewBox: "0 0 41.479 41.479"
  }, props), _ref);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='41.479' height='41.479' viewBox='0 0 41.479 41.479'%3e %3cpath fill='%235d1c9a' d='M-22884-427h-12a3 3 0 0 1-3-3 3 3 0 0 1 3-3h12v-29h.02a3 3 0 0 1 2.98-2.661 3 3 0 0 1 2.98 2.661h.02v35z' transform='rotate(45 -11997.081 27441.354)'/%3e %3c/svg%3e";
export { SvgCheckmark as ReactComponent };